import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoardService, BoardList, BoardPostList } from '../../services/board.service';
import { Util } from 'app/utils/util';
import _ from 'lodash';
import { AlertService } from '../../services/alert.service';

@Component({
  selector:'board-list',
  templateUrl: 'list.html'
})
export class BoardListComponent {
  page:number = 1;
  postList: BoardPostList;
  bbsId:string = null;
  dateFomatter:Function = Util.dateFomatter;  
  bbsNm:string = null;
  boardList: BoardList[];
  totalItem:number = null;

  constructor(private boardService:BoardService, private route:ActivatedRoute, private alertService:AlertService, private router: Router) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if(params['bbsId']) {
        this.bbsId = params['bbsId'];      
        if(!this.boardService.boardList) {
          this.boardService.getBoardList().subscribe(
            resp => {
              this.boardList = resp.data;
              this.getBoardName();
            }
          ); 
        } else {
          this.boardList = this.boardService.boardList;
          this.getBoardName();
        }

        this.getPostList();
      }
    });
  }


  getBoardName() {
    let bbs = _.find(this.boardList, {'bbsId': Number(this.bbsId)});
    if(bbs) {
      this.bbsNm = bbs.bbsNm;
    }
  }

  getPostList() {
    this.boardService.getPostListById(this.bbsId, this.page).subscribe(resp => {
      this.postList = resp.data;
      this.totalItem = resp.data.totalElems;
    });
  }

  handleClickEdit(post) {
    this.router.navigate(['board', 'edit', post.bbsId, post.cntntId]);
  }

  handleClickDelPost(post) {
    this.boardService.delBoardContents(post.bbsId, post.cntntId).subscribe(resp => {
      console.log(resp);
      if(resp.result) {
        this.alertService.success("게시물이 삭제되었습니다.");
        this.getPostList();
      } else {
        this.alertService.error(resp.errorMsg);
      }
    },
    error => {
      this.alertService.error(error.errorMsg);
    })
  }

  handleClickPageChange(event) {
    this.page = event;
    this.getPostList();
  }

  handleClickShowPreview(post) {
    this.router.navigate(['board', 'preview', post.bbsId, post.cntntId]);
  }
  




}


// WEBPACK FOOTER //
// ./src/app/containers/board/list.ts